module.exports = __webpack_public_path__ + "static/img/6.0195818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/6.png
// module id = /eLV
// module chunks = 0